import React, { Component } from 'react'
import * as rdd from 'react-device-detect';

export default class FbLineLogin extends Component {
    render() { 
        console.log("FbLineLogin");
    
        if (rdd.isMobile || rdd.isTablet){
            window.location.assign("line://app/1657746881-OnVGa7Yv");
        }
        else{
            window.location.assign("https://liff.line.me/1657746881-OnVGa7Yv");
        }
        return (<div>FB redirect to LINE...</div>)
        
    }
}
